import type { User, captureException } from '@sentry/react';
import { type ErrorInfo, createContext, useContext } from 'react';

interface SentryContext {
  sendSafeError: (
    error: unknown,
    errorInfo?: ErrorInfo,
    hint?: Parameters<typeof captureException>[1]
  ) => void;
  identifyUser: (user: User | null) => void;
}

export const SentryContext = createContext<SentryContext | null>(null);

export const useSentryContext = () => useContext(SentryContext)!;
